// JsFromRoutes CacheKey 40504959a9ae3f6f7b903a63128b3e13
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  readAll: /* #__PURE__ */ definePathHelper('post', '/users/:user_id/notifications/read_all'),
  markAsRead: /* #__PURE__ */ definePathHelper('post', '/users/:user_id/notifications/:id/mark_as_read'),
  index: /* #__PURE__ */ definePathHelper('get', '/users/:user_id/notifications'),
}
